<div class="col-12 widget" style="display: block">
  <canvas baseChart [datasets]="lineChartData" width="400" height="400" [labels]="lineChartLabels" [options]="lineChartOptions"
    [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType" [plugins]="lineChartPlugins">
  </canvas>
</div>